/**
 * Browser-safe compatibility bridge for UI modules originally written for the
 * Telegram Mini App. Desktop navigation renders its own controls, so Telegram
 * main/back buttons are intentionally no-ops.
 */

export function initTelegram(): void {
  // Desktop web authentication is cookie/Bearer based. No WebApp initData.
}

export function applyTelegramTheme(): void {
  // The desktop theme is owned by desktop.css.
}

export function haptic(type: 'light' | 'medium' | 'heavy' = 'light'): void {
  if (!('vibrate' in navigator)) return;
  const duration = type === 'heavy' ? 24 : type === 'medium' ? 16 : 8;
  try { navigator.vibrate(duration); } catch { /* optional enhancement */ }
}

export function showMainButton(_text: string, _cb: () => void): void {}
export function hideMainButton(): void {}
export function showBackButton(_cb: () => void): void {}
export function hideBackButton(): void {}

const browserBridge = {
  initData: '',
  initDataUnsafe: { user: null },
  platform: 'web',
  isVersionAtLeast: () => false,
  HapticFeedback: { impactOccurred: haptic },
  MainButton: { setText: () => {}, onClick: () => {}, offClick: () => {}, show: () => {}, hide: () => {} },
  BackButton: { onClick: () => {}, offClick: () => {}, show: () => {}, hide: () => {} },
  openLink: (url: string) => window.open(url, '_blank', 'noopener,noreferrer'),
};

export default browserBridge;
